'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@nordcom/nordstar';
import { Check, ChevronsUpDown, Plus } from 'lucide-react';
import type { Route } from 'next';
import Link from 'next/link';
import { cn } from '@/utils/tailwind';
export type ShopSwitcherShop = {
  name: string;
  domain: string;
};
export type ShopSwitcherProps = {
  current: ShopSwitcherShop;
  shops: ShopSwitcherShop[];
};

/**
 * Dropdown that lets operators switch between their accessible shops, navigating to the shop's root route on select.
 *
 * @param props.current - The currently active shop.
 * @param props.shops - All shops available in the switcher.
 */
export function ShopSwitcher(t0) {
  const $ = _c(19);
  const {
    current,
    shops
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex h-9 items-center gap-2 rounded-md border-2 border-border bg-background px-3 font-bold text-sm uppercase tracking-wide transition-colors hover:bg-muted");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== current.name) {
    t2 = <span className="truncate">{current.name}</span>;
    $[1] = current.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <DropdownMenu.Trigger className={t1}>{t2}{t3}</DropdownMenu.Trigger>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownMenu.Label>Switch shop</DropdownMenu.Label>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== current.domain || $[8] !== shops) {
    let t7;
    if ($[10] !== current.domain) {
      t7 = shop => {
        const active = shop.domain === current.domain;
        return <DropdownMenu.Item key={shop.domain} asChild={true}><Link href={`/${shop.domain}/` as Route} className="flex w-full items-center justify-between gap-2"><span>{shop.name}</span>{active ? <Check className="h-4 w-4" /> : null}</Link></DropdownMenu.Item>;
      };
      $[10] = current.domain;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t6 = shops.map(t7);
    $[7] = current.domain;
    $[8] = shops;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DropdownMenu.Separator />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DropdownMenu.Item asChild={true}><Link href={"/new" as Route} className="flex w-full items-center gap-2"><Plus className="h-4 w-4" />Connect a new Shop</Link></DropdownMenu.Item>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6) {
    t9 = <DropdownMenu.Content align="start" className="min-w-56">{t5}{t6}{t7}{t8}</DropdownMenu.Content>;
    $[14] = t6;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t9) {
    t10 = <DropdownMenu modal={false}>{t4}{t9}</DropdownMenu>;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}